import React from "react";
import { useDialog } from "./DialogProvider";
import ReminderDialog from "./ReminderDialog";

const GlobalReminderDialog = () => {
    const { dialogType, dialogData, hideDialog } = useDialog();
    if (dialogType !== "reminders") {
        return null;
    }

    return <ReminderDialog toggle={hideDialog} {...dialogData} />;
};

export default GlobalReminderDialog;
